<template>
  <div class="card">
    <div
      class="flex flex-col gap-0.5 text-sm bg-white border border-dark-secondary rounded-md p-3 shadow-2xs dark:bg-background-alt dark:border-dark-border"
    >
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Fecha / Hora:<b>{{ data.dateTime }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Folio/Correlativo: <b>{{ data.folio }}</b>
      </p>
      <Divider />
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Tipo de Transacción: <b>{{ data.transactionType.description }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Moneda: <b>{{ data.currencyType.description }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Forma de Abono: <b>{{ data.paymentMethod }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark mt-0.5"
      >
        Abono Cuenta <br />
        Propia o de Tercero:
        <b>{{ data.thirdPartyPayment ? "Tercero" : "Cuenta Propia" }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Secuencia: <b>{{ data.secuency.description }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
      >
        Documento <br />
        Adjunto:
        <CustomButton
          class="text-[14px]"
          icon="fa solid fa-paperclip"
          iconClass="text-[16px]"
          variant="link"
          label="Ver documento"
          @click="showPaymentDocument(data)"
        />
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        <span class=" ">Estado de Operación:</span>
        <span :class="getStatusClasses(data)" class="whitespace-nowrap">
          {{ data.status.description }}
        </span>
      </p>

      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
        v-if="data.status.description === 'Corregido'"
      >
        <span class=" ">Tipo de Corrección:</span>
        <span
          :class="getStatusTypeClasses(data.statusType.description)"
          class="whitespace-nowrap"
        >
          {{ data.statusType.description }}
        </span>
      </p>

      <Divider />

      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Rut Cliente: <b>{{ rutFormatter(data.clientData.rut) }}</b>
      </p>
      <p
        class="flex justify-between text-text-primary dark:text-text-primary-dark"
      >
        Nombre Cliente: <b>{{ data.clientData.name }}</b>
      </p>

      <template v-if="data.status.description != 'Corregido'">
        <div
          v-if="
            data.operationType === 1 ||
            data.operationType === 3 ||
            data.operationType === 5
          "
        >
          <div
            class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
            v-if="isAnalist && data.status.description != 'En Corrección'"
          >
            <span class="text-sm flex-1"
              >Monto en {{ data.currencyType.description }}:</span
            >
            <div style="width: 140px; height: 35px">
              <InputNumber
                inputClass=" w-[140px] h-[35px]"
                :disabled="disabledInput"
                v-model="data.amount"
                :inputId="
                  data.operationType === 1 ||
                  data.operationType === 3 ||
                  data.operationType === 5
                    ? 'integeronly'
                    : 'minmaxfraction'
                "
                :minFractionDigits="data.currencyType.id === 1 ? 0 : 2"
                :maxFractionDigits="5"
                fluid
              />
            </div>
          </div>
          <p
            v-else
            class="flex justify-between text-text-primary dark:text-text-primary-dark"
          >
            Monto en {{ data.currencyType.description }}:
            <b>{{
              data.operationType === 1 || data.operationType === 2
                ? formatPrice(data.amount, "$")
                : formatPrice(data.amount, "$", 2)
            }}</b>
          </p>
          <div
            class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
            v-if="isAnalist && data.status.description != 'En Corrección'"
          >
            Banco
            {{
              data.operationType === 4 || data.operationType === 6
                ? "Pagador"
                : "Credicorp"
            }}:
            <div>
              <div style="width: 140px; height: 35px">
                <CustomSelect
                  :disabled="disabledInput"
                  class="w-35 h-8.75"
                  selectClass="items-center mt-2 text-sm !w-[140px] h-[35px]"
                  v-model="data.bankCrediCorp.id"
                  optionLabel="description"
                  optionValue="id"
                  placeholder="Seleccione"
                  :options="banksList"
                />
              </div>
            </div>
          </div>
          <p
            v-else
            class="flex justify-between text-text-primary dark:text-text-primary-dark"
          >
            Banco Credicorp: <b>{{ data.bankCrediCorp.description }}</b>
          </p>
        </div>
        <div v-else>
          <p
            class="flex justify-between text-text-primary dark:text-text-primary-dark"
          >
            items-center"> Monto en {{ data.currencyType.description }}:
            <b
              :style="{
                color: '#34a649',
              }"
              >{{
                data.operationType === 4 || data.operationType === 6
                  ? formatPrice(data.amount, "", 2)
                  : formatPrice(data.amount, "$")
              }}</b
            >
          </p>
          <p
            class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
          >
            Banco Pagador:
            <b>{{ data.bankCrediCorp.description }}</b>
          </p>
        </div>
        <p
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center mt-2 mb-2"
        >
          {{
            data.operationType === 1 ||
            data.operationType === 3 ||
            data.operationType === 5
              ? "Cuenta Credicorp"
              : "Cuenta Pagadora"
          }}:
          <b>{{ data.bankCrediCorp.accountNumber }} </b>
        </p>
      </template>
      <template
        v-else-if="
          data.operationType === 1 ||
          data.operationType === 3 ||
          data.operationType === 5
        "
      >
        <div
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          <b class="text-sm flex-1 mt-2" style="color: #ea6b58"
            >Monto Inicial en {{ data.currencyType.description }}:</b
          >
          <div style="width: 140px; height: 35px">
            <InputNumber
              inputClass=" w-[140px] h-[35px]"
              :disabled="disabledInput"
              v-model="data.amount"
              :inputId="
                data.operationType === 1 ||
                data.operationType === 3 ||
                data.operationType === 5
                  ? 'integeronly'
                  : 'minmaxfraction'
              "
              :minFractionDigits="data.currencyType.id === 1 ? 0 : 2"
              :maxFractionDigits="5"
              fluid
            />
          </div>
        </div>

        <div
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center font-700"
          style="color: #ea6b58"
        >
          <p>Banco Credicorp Inicial:</p>
          <div style="width: 140px; height: 35px">
            <CustomSelect
              :disabled="disabledInput"
              class="w-35 h-8.75"
              selectClass="items-center mt-2 text-sm !w-[140px] h-[35px]"
              v-model="data.bankCrediCorp.id"
              optionLabel="description"
              optionValue="id"
              placeholder="Seleccione"
              :options="banksList"
              @change="changeBankCrediCorp(data.bankCrediCorp.id)"
            />
          </div>
        </div>
        <p
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center mt-3 mb-"
          style="color: #ea6b58"
        >
          <b> Cuenta Credicorp Inicial:</b>
          <b>{{ data.bankCrediCorp.accountNumber }} </b>
        </p>
        <p
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          <b>Monto Final en {{ data.currencyType.description }}: </b>
          <b
            >{{
              data.operationType === 4 || data.operationType === 6
                ? formatPrice(amountFinal, "", 2)
                : formatPrice(amountFinal, "")
            }}
          </b>
        </p>

        <p
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          <b>Banco Credicorp Final:</b>
          <b>{{ bankFinal }} </b>
        </p>

        <p
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          <b>Cuenta Credicorp Final:</b>
          <b>{{ accountFinal }} </b>
        </p>
      </template>
      <template v-else>
        <p
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          Monto En {{ data.currencyType.description }}:
          <b style="color: #34a649"
            >{{
              data.operationType === 1 || data.operationType === 2
                ? formatPrice(data.amount, "$")
                : formatPrice(data.amount, "$", 2)
            }}
          </b>
        </p>
        <b
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          Banco Pagador:
          <p>{{ data.bankCrediCorp.description }}</p>
        </b>
        <b
          class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        >
          Cuenta Pagadora:
          <p>{{ data.bankCrediCorp.accountNumber }}</p>
        </b>
      </template>
      <div
        v-if="isAnalist && data.status.description != 'En Corrección'"
        class="flex justify-between text-text-primary dark:text-text-primary-dark items-center"
        :class="data.status.description === 'Corregido' ? 'mb-1' : ''"
      >
        <span class="text-sm flex-1">Referencia:</span>
        <div style="width: 140px; height: 35px">
          <!-- :disabled="disabledInput" -->
          <CustomInput
            v-model="data.reference"
            inputClass="w-[162px] h-[35px]"
            :inputId="
              data.currencyType.id === 1 || data.currencyType.id === 2
                ? 'integeronly'
                : 'minmaxfraction'
            "
            :minFractionDigits="
              data.currencyType.id === 1 || data.currencyType.id === 2 ? 0 : 2
            "
            :maxFractionDigits="5"
            fluid
          />
        </div>
      </div>
      <p v-else class="flex justify-between">
        Referencia: <b>{{ data.reference }}</b>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, defineAsyncComponent } from "vue";

const CustomButton = defineAsyncComponent(
  () => import("../ui/CustomButton.vue"),
);
const CustomSelect = defineAsyncComponent(
  () => import("../ui/CustomSelect.vue"),
);

import { useCurrencyFormatter } from "../../composables/useFormatPrice";
import { rutFormatter } from "@/utils/rutFormatter";

const { formatPrice } = useCurrencyFormatter();
const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  banksList: {
    type: Array,
    default: () => [],
  },
  isAnalist: {
    type: Boolean,
    default: false,
  },
});

const paymentDocumentData = ref<any>(null);
const showPaymentDocumentModal = ref(false);
const operationDetails = ref<any>(props.data);
const amountFinal = ref<number>(0);
const bankFinal = ref<string>("");
const accountFinal = ref<string>("");

function init() {
  amountFinal.value = operationDetails.value.amount;
  bankFinal.value = operationDetails.value.bankCrediCorp.description;
  accountFinal.value = operationDetails.value.bankCrediCorp.accountNumber;
  props.data.amount = operationDetails.value.operationDetails[0].amount;
  props.data.bankCrediCorp.id =
    operationDetails.value.operationDetails[0].bankCrediCorp.id;
  props.data.bankCrediCorp.accountNumber =
    operationDetails.value.operationDetails[0].bankCrediCorp.accountNumber;
}

function getStatusTypeClasses(type: any): string[] {
  let baseClasses = ["font-700 "];
  if (type === "Aprobado") {
    baseClasses.push("text-icon-success");
  } else if (type === "Rechazado") {
    baseClasses.push("text-text-error");
  } else if (type === "Devolución") {
    baseClasses.push("text-accent-sky-60");
  }
  return baseClasses;
}

function getStatusClasses(data: any): string[] {
  const baseClasses = [
    "text-[10px]",
    "w-[95px]",
    "inline-flex",
    "justify-between",
    "items-center",
    "border",
    "px-2",
    "py-1",
    "rounded-md",
    "bg-surface-tertiary",
    "border-section-title",
    "dark:border-dark-border",
  ];
  if (data.status.description === "Pendiente") {
    baseClasses.push(
      "!text-primary-dark-border",
      "border-border-upload-excel!",
      "bg-dark-secondary!",
    );
  } else if (data.status.description === "En Corrección") {
    baseClasses.push(
      "text-text-primary!",
      "border-neutral-gray-80!",
      "bg-surface-tertiary!",
    );
  } else if (data.status.description === "Corregido") {
    if (data.statusType.description === "Aprobado") {
      baseClasses.push(
        "text-text-primary!",
        "border-forest-maid!",
        "bg-background-success-minimal!",
      );
    } else if (data.statusType.description === "Rechazado") {
      baseClasses.push(
        "text-text-primary!",
        "border-helper-text!",
        "bg-background-error-minimal!",
      );
    } else if (data.statusType.description === "Devolución") {
      baseClasses.push(
        "text-text-primary!",
        "border-border-focus!",
        "bg-background-info-minimal!",
      );
    }
  } else if (data.status.description === "Validado") {
    baseClasses.push(
      "text-text-primary!",
      "border-icon-warning!",
      "bg-background-warning-minimal!",
    );
  } else if (data.status.description === "En Pago Unitario") {
    baseClasses.push(
      "text-text-primary!",
      "border-uniform!",
      "bg-background-info-minimal!",
    );
  } else if (data.status.id === 8) {
    baseClasses.push(
      "text-text-primary!",
      "border-forest-maid!",
      "bg-background-success-minimal!",
    );
  } else if (data.status.id === 9) {
    baseClasses.push(
      "text-text-primary!",
      "border-helper-text!",
      "bg-background-error-minimal!",
    );
  }
  return baseClasses;
}

function showPaymentDocument(data: any) {
  // TODO: se debe eliminar data porq lo q abre es una vista sin nada pero con una imagen dentro que lo entrega el backend
  paymentDocumentData.value = data;
  showPaymentDocumentModal.value = true;
}

function changeBankCrediCorp(bankId: number) {
  type Bank = { id: number; description: string; accountNumber: string };
  let row: Bank | undefined = props.banksList.find(
    (bank: any) => bank.id === bankId,
  ) as Bank | undefined;
  if (row) {
    props.data.bankCrediCorp.id = row.id;
    props.data.bankCrediCorp.description = row.description;
    props.data.bankCrediCorp.accountNumber = row.accountNumber;
  }
}

const disabledInput = computed(() => {
  return (
    props.data.status.description === "Validado" ||
    props.data.statusType.description === "Rechazado" ||
    props.data.status.description === "En Corrección"
  );
});

onMounted(() => {
  init();
});
</script>
